export default __webpack_public_path__ + "static/media/trio_2.fc69579c.dae";